import { FC } from 'react';

import { IconProps } from '../types';

export const MaxIcon: FC<IconProps> = ({ size, height = 24, width = 24, color = '#06519E' }) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 24 24"
		width={size ?? width}
		height={size ?? height}
	>
		<path
			fill={color}
			fillRule="evenodd"
			d="M12.568 20.246c-1.766 0-2.587-.258-4.014-1.29-.903 1.161-3.76 2.068-3.885.516 0-1.164-.258-2.149-.55-3.223-.349-1.324-.744-2.798-.744-4.934 0-5.102 4.186-8.94 9.146-8.94 4.964 0 8.854 4.027 8.854 8.987a8.854 8.854 0 0 1-8.807 8.884Zm.073-13.461c-2.415-.125-4.298 1.547-4.714 4.169-.344 2.17.266 4.813.786 4.951.25.06.877-.447 1.268-.838a4.47 4.47 0 0 0 2.183.778 4.599 4.599 0 0 0 4.81-4.285 4.599 4.599 0 0 0-4.333-4.771v-.004Z"
		/>
	</svg>
);
